import { createSlice, current } from "@reduxjs/toolkit";
import apiService from "../../api/apiService";
import { endPoints } from "../../api/endpoints";
import { formatAxiosErrorMessage, qargsToQstring } from "../../utils/common";

const SupportInitialState = {
  list: {
    isLoading: false,
    data: null,
    error: null,
  },
  create: {
    isLoading: false,
    isSuccess: false,
    data: null,
    error: null,
  },
  delete: {
    isLoading: false,
    isSuccess: false,
    error: null,
  },
};

export const SupportSlice = createSlice({
  name: "support",
  initialState: {
    ...SupportInitialState,
  },
  reducers: {
    supportListRequesting: (state) => {
      state.list.isLoading = true;
    },
    supportListSuccess: (state, action) => {
      state.list.isLoading = false;
      state.list.error = null;
      state.list.data = action.payload.data;
    },
    supportListError: (state, action) => {
      state.list.isLoading = false;
      state.list.error = action.payload;
    },
    supportListReset: (state) => {
      state.list = SupportInitialState.list;
    },

    supportCreateRequesting: (state) => {
      state.create.isLoading = true;
      state.create.isSuccess = false;
    },
    supportCreateSuccess: (state, action) => {
      state.create.isLoading = false;
      state.create.isSuccess = true;
      state.create.error = null;
      state.create.data = action.payload.data;
      // prepend to list if present
      if (state.list.data && state.list.data.results) {
        state.list.data.results.unshift(action.payload.data);
      }
    },
    supportCreateError: (state, action) => {
      state.create.isLoading = false;
      state.create.isSuccess = false;
      state.create.error = action.payload;
    },
    supportCreateReset: (state) => {
      state.create = SupportInitialState.create;
    },

    supportDeleteRequesting: (state) => {
      state.delete.isLoading = true;
      state.delete.isSuccess = false;
    },
    supportDeleteSuccess: (state) => {
      state.delete.isLoading = false;
      state.delete.isSuccess = true;
      state.delete.error = null;
    },
    supportDeleteError: (state, action) => {
      state.delete.isLoading = false;
      state.delete.isSuccess = false;
      state.delete.error = action.payload;
    },
    supportDeleteReset: (state) => {
      state.delete = SupportInitialState.delete;
    },
  },
});

export const {
  supportListRequesting,
  supportListSuccess,
  supportListError,
  supportListReset,
  supportCreateRequesting,
  supportCreateSuccess,
  supportCreateError,
  supportCreateReset,
  supportDeleteRequesting,
  supportDeleteSuccess,
  supportDeleteError,
  supportDeleteReset,
} = SupportSlice.actions;

export default SupportSlice.reducer;

export const getSupportListAPI = (query = {}) => async (dispatch) => {
  dispatch(supportListRequesting());
  try {
    const qstring = qargsToQstring(query);
    const response = await apiService.get(`${endPoints.support.tickets}${qstring}`);
    dispatch(supportListSuccess(response.data));
  } catch (err) {
    dispatch(supportListError(formatAxiosErrorMessage(err)));
  }
};

export const createSupportTicketAPI = (data) => async (dispatch) => {
  dispatch(supportCreateRequesting());
  try {
    const response = await apiService.post(endPoints.support.tickets, data, { headers: { 'Content-Type': 'multipart/form-data' } });
    dispatch(supportCreateSuccess(response.data));
  } catch (err) {
    dispatch(supportCreateError(formatAxiosErrorMessage(err)));
  }
};

export const deleteSupportTicketAPI = (id) => async (dispatch) => {
  dispatch(supportDeleteRequesting());
  try {
    const url = endPoints.support.ticketDetail.replace("{{id}}", id);
    await apiService.delete(url);
    dispatch(supportDeleteSuccess());
  } catch (err) {
    dispatch(supportDeleteError(formatAxiosErrorMessage(err)));
  }
};
